import React, { useCallback, useEffect, useState, useRef } from "react";
import Layout1 from "../../DataLayouts/Layout1";
import NextWeekIcon from "@mui/icons-material/NextWeek";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import { fetchEmployeeLeaveMonthlySummaryReport } from "../../../Apis/Employee-api";
import { MAIN_URL } from "../../../Configurations/Urls";
import DateRangeIcon from "@mui/icons-material/DateRange";
import PersonIcon from "@mui/icons-material/Person";
import CategoryIcon from "@mui/icons-material/Category";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import toast from "react-hot-toast";
import axios from "axios";
import TableDataGeneric from "../../../Configurations/TableDataGeneric";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Layout4 from "../../DataLayouts/Layout4";
import { operatorRequiresValue } from "../../../Components/filters/operators";

const DEFAULT_COLUMNS = [
  {
    field: "employee_name",
    label: "employee_name",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "employee_code",
    label: "employee_code",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },

  
  {
    field: "year",
    label: "year",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  
  {
    field: "month",
    label: "month",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "total_leave_days",
    label: "total_leave_days",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "approved_leave_days",
    label: "approved_leave_days",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "unapproved_leave_days",
    label: "unapproved_leave_days",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "casual_leaves",
    label: "casual_leaves",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "medical_leaves",
    label: "medical_leaves",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "earned_leaves",
    label: "earned_leaves",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "compensatory_off_leaves",
    label: "compensatory_off_leaves",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "leave_without_pay",
    label: "leave_without_pay",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "leave_with_pay",
    label: "leave_with_pay",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

const DEFAULT_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 1,
  hasNext: false,
  hasPrev: false,
  prev_page: null,
  next_page: null,
};

const buildFiltersFromParams = (searchParams) => {
  const filters = [];
  const processedFields = new Set();
  searchParams.forEach((value, key) => {
    if (key.endsWith("_operator") || key.endsWith("_logic") || !key.startsWith("filter_")) return;
    const field = key.replace("filter_", "");
    if (processedFields.has(field)) return;
    processedFields.add(field);
    const operator = searchParams.get(`filter_${field}_operator`) || "contains";
    const requiresValue = operatorRequiresValue(operator);
    if (!requiresValue || value) {
      let filterValue = requiresValue ? value : null;
      if (requiresValue && filterValue) {
        if (["equals", "not_equals"].includes(operator)) {
          filterValue = filterValue.split(",").map((v) => v.trim().toLowerCase());
        } else if (["between", "not_between"].includes(operator)) {
          filterValue = filterValue.split(",").map((v) => v.trim());
        }
      }
      filters.push({ field, operator, value: filterValue });
    }
  });
  return filters;
};

function LeaveSummaryMonthlyReport() {
  const [leaves, setLeaves] = useState([]);
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const [loading, setLoading] = useState(true);
  const [tableConfig, setTableConfig] = useState(null);
  const [configColumns, setConfigColumns] = useState(DEFAULT_COLUMNS);
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [paginationData, setPaginationData] = useState(DEFAULT_PAGINATION);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const fetchControllerRef = useRef(null);

  const { id } = useParams();

  // Load table configuration from general-datagrids API
  useEffect(() => {
    const loadTableConfiguration = async () => {
      if (!org?.organization_id) {
        setLoadingConfig(false);
        return;
      }

      try {
        const configRes = await fetch(`${MAIN_URL}/api/general-datagrids`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (configRes.ok) {
          const configResponse = await configRes.json();
          const datagrids = configResponse.datagrids || [];
          const orgKey = `organization_person_leave_monthly_summaries_grid_${org.organization_id}`;
          const savedConfig = datagrids.find(
            (dg) => dg.datagrid_key === orgKey
          );

          if (savedConfig) {
            const serverCfg = savedConfig.datagrid_default_configuration;
            setTableConfig(serverCfg);

            if (
              serverCfg?.columns &&
              Array.isArray(serverCfg.columns) &&
              serverCfg.columns?.length > 0
            ) {
              setConfigColumns(serverCfg.columns);
            } else {
              setConfigColumns(DEFAULT_COLUMNS);
            }
          } else {
            setConfigColumns(DEFAULT_COLUMNS);
          }
        }
      } catch (error) {
        console.error("Error loading table configuration:", error);
        setConfigColumns(DEFAULT_COLUMNS);
      } finally {
        setLoadingConfig(false);
      }
    };

    loadTableConfiguration();
  }, [org?.organization_id]);

  // Load data via POST /filters (metadata-driven) or fallback to GET
  useEffect(() => {
    if (!org?.organization_id) return;
    fetchControllerRef.current?.abort();
    fetchControllerRef.current = new AbortController();
    setLoading(true);

    const fetchData = async () => {
      try {
        const filters = buildFiltersFromParams(searchParams);
        const search = searchParams.get("search");
        const requestBody = {
          filters,
          page: Number.parseInt(searchParams.get("page"), 10) || 1,
          pageSize: Number.parseInt(searchParams.get("pageSize"), 10) || 10,
          sort: {
            field: searchParams.get("sortBy") || "organization_person_leave_monthly_summary_id",
            direction: searchParams.get("sortOrder") || "desc",
          },
          ...(search && search.trim() !== "" && { search: search.trim() }),
        };
        const response = await fetch(
          `${MAIN_URL}/api/organizations/${org.organization_id}/employee-monthlyleave-summary/filters`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
            signal: fetchControllerRef.current.signal,
          }
        );

        let data = [];
        if (response.ok) {
          const result = await response.json();
          data = result.data ?? result.summary ?? [];
          if (result.success && result.pagination) {
            setPaginationData({
              page: result.pagination.page ?? 1,
              pageSize: result.pagination.pageSize || result.pagination.limit || 10,
              total: result.pagination.total || 0,
              totalPages: result.pagination.totalPages || 1,
              hasNext: result.pagination.hasNext || false,
              hasPrev: result.pagination.hasPrev || false,
              prev_page: result.pagination.prev_page ?? null,
              next_page: result.pagination.next_page ?? null,
            });
          } else if (!result.success) {
            setPaginationData(DEFAULT_PAGINATION);
          }
        } else if (response.status === 503 || response.status === 404) {
          const fallback = await fetchEmployeeLeaveMonthlySummaryReport(org.organization_id);
          data = fallback?.summary || [];
          setPaginationData(DEFAULT_PAGINATION);
        } else {
          throw new Error(`HTTP ${response.status}`);
        }
        setLeaves(
          data.map((item) => ({
            ...item,
            id: item?.organization_person_leave_monthly_summary_id || "",
          }))
        );
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error("Error fetching employee leave monthly summary:", err);
        toast.error("Failed to load employee leave monthly summary report");
        setLeaves([]);
        setPaginationData(DEFAULT_PAGINATION);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    return () => fetchControllerRef.current?.abort();
  }, [org, searchParams]);

  let deleteemployeeleave = async (id) => {
    try {
      const org_id = org.organization_id;
      const response = await axios.delete(
        `${MAIN_URL}/api/organizations/${org_id}/employee-entitlements/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!");
        window.location.href = "/login";
      }
      console.error("Delete failed:", error);
      toast.error(
        error.response?.data?.error ||
          "Failed to delete Employee Leave Entitlement"
      );
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-monthlyleave-summary/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      console.log("Successfully deleted units-types with id:", id);
      return Promise.resolve();
    } catch (error) {
      console.error("Delete failed:", error);
      return Promise.reject(error);
    }
  };

  const handleEdit = useCallback(
    (item) => {
      navigate(`/organization/employee/employee-exits/edit/${item.id}`);
    },

    [navigate]
  );

  return (
    <>
      <Layout4
        loading={loading}
        heading={"Employee Leave Monthly Summary Report"}
        btnName={null}
        Data={leaves}
        tableHeaders={[
          {
            name: "Employee Name",
            value_key: "fullname",
            textStyle: "capitalize",
          },
          { name: "Employee Code", value_key: "employee_code" },
          { name: "Year", value_key: "year" },
          { name: "Month", value_key: "month" },
          { name: "Total Leave Days", value_key: "total_leave_days" },
          { name: "Approved", value_key: "approved_leave_days" },
          { name: "UnApproved", value_key: "unapproved_leave_days" },
          { name: "Casual", value_key: "casual_leaves" },
          { name: "Medical", value_key: "medical_leaves" },
          { name: "Earned", value_key: "earned_leaves" },
          { name: "Compensatory", value_key: "compensatory_off_leaves" },
          { name: "Leave Without Pay", value_key: "leave_without_pay" },
          { name: "Leave With Pay", value_key: "leave_with_pay" },
        ]}
        Icons={[
          <PersonIcon sx={{ fontSize: 60, color: "grey.500", mb: 2 }} />,
          <FormatAlignJustifyIcon color="primary" />,
          <CategoryIcon sx={{ color: "text.secondary" }} />,
          <DateRangeIcon sx={{ color: "text.secondary" }} />,
        ]}
        messages={[
          "Employee Leave Monthly Summary Report",
          "Employee Leave Monthly Summary Report",
          "Add Employee Monthly Summary Report",
          "Employee Leaves Monthly Summary Report",
        ]}
        Route={"employee-leave-balance-report"}
        setData={setLeaves}
        DeleteFunc={deleteemployeeleave}
      />

      <TableDataGeneric
        tableName="organization_person_leave_monthly_summaries"
        primaryKey="organization_person_leave_monthly_summary_id"
        heading="Employee Leave Monthly Summary Report"
        data={leaves}
        sortname={"employee_name"}
        showActions={false}
        Route="/employee-leave-summary"
        DeleteFunc={handleDelete}
        EditFunc={handleEdit}
        token={localStorage.getItem("token")}
        configss={configColumns}
        paginationData={paginationData}
        filterModule="employee_leave_monthly_summaries"
        {...(tableConfig && { config: tableConfig })}
      />
    </>
  );
}

export default LeaveSummaryMonthlyReport;
